module.exports = __webpack_public_path__ + "static/img/brees-2018-slide-4.0b1da6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-slide-4.jpg
// module id = utVa
// module chunks = 1